export const resetPassword = {
  'resetPassword.title': 'Ponastavite geslo',
  'resetPassword.description': 'Vnesite novo geslo.',
  'resetPassword.buttonResetPassword': 'Ponastavite geslo',
  'resetPassword.backToLogIn': 'Nazaj na prijavo',
  'resetPassword.textLabelNewPass': 'Novo geslo',
  'resetPassword.textLabelConfirmPass': 'Potrdite geslo',
  'resetPassword.successMessage': 'Vaše geslo je bilo uspešno spremenjeno',
}
